import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import firebaseApp from "./fireconnect";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDataContext } from "./DataContext";

export default function Blog({ excludeId }) {
  const {
    blogs: cachedBlogs,
    setBlogs: setCachedBlogs,
    blogsFetched,
    setBlogsFetched,
  } = useDataContext();

  const [blogs, setBlogs] = useState(cachedBlogs.filter((blog) => blog.id !== excludeId));
  const [loading, setLoading] = useState(!blogsFetched);

  useEffect(() => {
    const fetchBlogs = async () => {
      // If data is already cached, use it
      if (blogsFetched && cachedBlogs.length > 0) {
        const filteredBlogs = cachedBlogs.filter((blog) => blog.id !== excludeId);
        setBlogs(filteredBlogs);
        setLoading(false);
        return;
      }

      try {
        const db = firebaseApp.firestore();
        const querySnapshot = await db.collection("Blog").get();

        const blogsData = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          formattedDate:
            doc.data().formattedDate || new Date().toLocaleDateString(),
        }));

        const filteredBlogs = blogsData.filter((blog) => blog.id !== excludeId);

        setBlogs(filteredBlogs);
        setLoading(false);

        // Update cache
        setCachedBlogs(blogsData);
        setBlogsFetched(true);
      } catch (error) {
        console.error("Error fetching blogs: ", error);
        setLoading(false);
      }
    };

    fetchBlogs();
  }, [excludeId, blogsFetched, cachedBlogs, setCachedBlogs, setBlogsFetched]);

  const truncateContent = (content, maxLength = 200) => {
    if (content.length > maxLength) {
      return content.substring(0, maxLength) + "...";
    }
    return content;
  };

  return (
    <section>
      <Container>
        <div className="blogmain">
          <Row>
            {loading
              ? Array.from({ length: 4 }).map((_, index) => (
                <Col
                  key={index}
                  xs={12}
                  md={6}
                  className="mb-4 px-lg-4 px-md-3"
                >
                  <div className="d-flex h-100 w-100">
                    <div
                      className="BlogCard h-100 w-100 border-0 rounded-4 overflow-hidden"
                      style={{
                        padding: "16px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                      }}
                    >
                      <Skeleton height={260} borderRadius={16} />

                      <div className="Bbogbody p-3">
                        <p className="BlogformattedDate">
                          <Skeleton width={100} height={20} borderRadius={16} />
                        </p>
                        <h5 className="Blogtitle mt-2 fw-bold">
                          <Skeleton width={500} height={20} count={2} />
                        </h5>
                        <p
                          className="Blogcontent mt-3 ps-5"
                        >
                          <Skeleton count={2} width={400} height={20} />
                        </p>
                        <span className="mt-4 text-uppercase fw-bold">
                          <Skeleton width={120} height={30} borderRadius={16} />
                        </span>
                      </div>
                    </div>
                  </div>
                </Col>
              ))
              : blogs.map((blog) => (
                <Col
                  key={blog.id}
                  xs={12}
                  md={6}
                  className="mb-4 px-lg-4 px-md-3"
                >
                  <div className="text-decoration-none d-flex h-100">
                    <Link
                      to={`/blog/${blog.id}`}
                      className="text-decoration-none d-flex h-100"
                    >
                      <div className="BlogCard h-100 border-0 overflow-hidden">
                        <div className="blogheader d-flex rounded-4">
                          <img
                            alt={blog.title}
                            src={blog.image}
                            className="incardimg img-fluid rounded-4"
                            loading="lazy"
                          />
                        </div>
                        <div className="Bbogbody p-3">
                          <p className="BlogformattedDate">
                            {blog.formattedDate}
                          </p>
                          <h5 className="Blogtitle mt-2 fw-bold">
                            {blog.title}
                          </h5>
                          <p
                            className="Blogcontent mt-3"
                            dangerouslySetInnerHTML={{
                              __html: truncateContent(blog.content),
                            }}
                          />
                          <span className="read-more-btn mt-4 text-uppercase fw-bold">
                            Read More
                          </span>
                        </div>
                      </div>
                    </Link>
                  </div>
                </Col>
              ))}
          </Row>
        </div>
      </Container>
    </section>
  );
}
